export const album = {
  state () {
    return {
      currentAlbum: null
    }
  },
  mutations: {
    setCurrentAlbum (state, album) {
      if (typeof album === 'object') {
        state.currentAlbum = album
      } else {
        throw new TypeError('album is not a object')
      }
    },

    clearCurrentAlbum(state) {
      state.currentAlbum = null
    }
  },
  getters: {
    currentAlbum (state) {
      return state.currentAlbum
    },
  },
  actions: {

  }

}



// WEBPACK FOOTER //
// ./src/store/modules/album/index.js